import { setDoc } from "firebase/firestore";
import { version } from '~~/package.json';

export default defineNuxtPlugin(() => {
  const bootstrapStore = useBootstrapStore();
  const settingsStore = useSettingsStore();
  const authStore = useAuthStore();
  const shopStore = usePosShopStore();
  const firestore = useFirestore();
  const { theme } = useTheme();

  let unwatchStoreName: (() => void) | undefined;
  let lastSyncedStoreName = "";

  const syncStoreName = async (nextStoreName: string) => {
    const normalizedName = (nextStoreName || "").trim();
    if (!normalizedName) return;
    if (!authStore.storeId) return;
    if (normalizedName === lastSyncedStoreName) return;

    const storeRef = useFirestore().getRootDataRef()
    try {
      await setDoc(
        storeRef,
        {
          name: normalizedName,
          version,
          colorTheme: theme.value === 'dark' ? 'Dark' : 'Light',
        },
        { merge: true }
      );

      lastSyncedStoreName = normalizedName;
    } catch (error) {
      console.error("[storeName plugin] Failed to sync storeName:", error);
    }
  };

  watch(
    () => bootstrapStore.loaded,
    (isLoaded) => {
      if (isLoaded) {
        if (shopStore.runMode !== 'cashier') return;
        if (unwatchStoreName) return;

        unwatchStoreName = watch(
          () => settingsStore.storeName,
          (newStoreName, oldStoreName) => {
             
            if (newStoreName === oldStoreName) return;
            void syncStoreName(newStoreName);
          },
          { immediate: true }
        );
        return;
      }

      if (unwatchStoreName) {
        unwatchStoreName();
        unwatchStoreName = undefined;
      }
    },
    { immediate: true }
  );
});
